module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/assessment_achievements/5_a6d36a18fda22d020217efef4777354e.png";